// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bcn_a bho_a bho_r bho_j","ModeratorInvitationListItem__left":"bcn_b bho_a bho_j","ModeratorInvitationListItem__note":"bcn_c bho_fo"};